import axios from 'axios';
import { getToken } from '../../api/tokens';
import { Token } from '../../interfaces/api/token';
import dayjs from '../../helpers/dayjs';
import Cookies from 'js-cookie';

export async function authentication(
	username: string,
	password: string,
	withToken: boolean
): Promise<Token> {
	try {
		const data = await getToken(username, password);
		axios.defaults.headers.common['Authorization'] = `Token ${data.token}`;
		if (withToken) {
			Cookies.set('Token', JSON.stringify({ token: data.token }), {
				expires: dayjs().utc(true).add(4, 'h').toDate(),
				secure: process.env.NODE_ENV === 'production',
				sameSite: 'strict',
				path: process.env.REACT_APP_COOKIE_PATH,
				domain: process.env.REACT_APP_COOKIE_DOMAIN,
			});
		}

		return data;
	} catch (error) {
		throw error;
	}
}

export function logout(): void {
	Cookies.remove('Token');
}
